<template>
  <div class="form-wrapper">
    <div class="w-100">
      <v-skeleton-loader
        type="button"
        width="120"
        height="40"
      />
    </div>

    <div class="two-col-grid">
      <div
        v-for="col in 2"
        :key="`top-${col}`"
        class="d-flex flex-column min-width-0"
      >
        <v-skeleton-loader
          type="text"
          width="180"
          height="20"
          class="mb-3"
        />
        <v-skeleton-loader
          type="text"
          width="100%"
          height="48"
          class="mb-2"
        />
        <v-skeleton-loader
          type="text"
          width="112"
          height="25"
        />
      </div>
    </div>

    <v-skeleton-loader
      type="text"
      width="280"
      height="24"
    />

    <div class="two-col-grid">
      <div
        v-for="col in 2"
        :key="`sla-${col}`"
        class="d-flex flex-column min-width-0"
      >
        <v-skeleton-loader
          type="text"
          width="220"
          height="20"
          class="mb-3"
        />
        <div class="d-flex align-center ga-2">
          <v-skeleton-loader
            type="text"
            width="75"
            height="40"
          />
          <v-skeleton-loader
            type="text"
            width="36"
            height="20"
          />
        </div>
        <v-skeleton-loader
          type="text"
          width="112"
          height="25"
          class="mt-2"
        />
      </div>
    </div>

    <v-skeleton-loader
      type="text"
      width="260"
      height="24"
    />
    <v-skeleton-loader
      type="text"
      width="560"
      height="20"
      class="mb-4"
    />

    <div
      v-for="block in 3"
      :key="`lang-${block}`"
      class="textarea-block-skeleton"
    >
      <v-skeleton-loader
        type="text"
        width="200"
        height="20"
        class="mb-3"
      />
      <v-skeleton-loader
        type="text"
        width="480"
        height="16"
        class="mb-3"
      />
      <v-skeleton-loader
        type="text"
        width="632"
        height="200"
        class="mb-3"
      />
      <div class="d-flex justify-space-between align-center w-100">
        <v-skeleton-loader
          type="text"
          width="112"
          height="25"
        />
        <v-skeleton-loader
          type="text"
          width="72"
          height="18"
        />
      </div>
    </div>

    <v-skeleton-loader
      type="button"
      width="120"
      height="40"
    />
  </div>
</template>

<style scoped lang="less">
.form-wrapper {
  border-radius: 10px;
  background: @white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 35px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.two-col-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
}

.textarea-block-skeleton {
  width: 100%;
  max-width: 632px;
  display: flex;
  flex-direction: column;
}
</style>
